/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: (props) => ({
        checkmarkBenefits: {
            color: props.hasLightBg ? 'black' : 'white',
            marginBottom: 10,
            paddingLeft: 0,
            ...props.theme.textStyles.light2Xlarge
        },
        checkmark: {
            width: 8,
            height: 8,
            marginRight: 4,
            position: 'absolute',
            left: 0
        },
        checkmarkBenefitsListItem: {
            position: 'relative',
            paddingLeft: '48px'
        }
    }),
    parts: ['checkmark', 'checkmarkBenefits', 'checkmarkBenefitsListItem']
}
